var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "qmsForm",
          attrs: { model: _vm.qmsForm, "label-width": "100px" },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "处理意见",
                        prop: "processingModeSuggestion",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          maxlength: "1000",
                          "show-word-limit": "",
                          autosize: { minRows: 4, maxRows: 6 },
                          placeholder: "请输入内容",
                        },
                        model: {
                          value: _vm.qmsForm.processingModeSuggestion,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.qmsForm,
                              "processingModeSuggestion",
                              $$v
                            )
                          },
                          expression: "qmsForm.processingModeSuggestion",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        {
          staticStyle: { "margin-top": "10px" },
          attrs: { type: "flex", justify: "center" },
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.saveConfirm },
            },
            [_vm._v("保存")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.onCancel },
            },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }